import { useMemo, useState } from 'react';
import { FilterPillBar } from '../components/FilterPillBar.jsx';
import { CategoryRow } from '../components/CategoryRow.jsx';
import { CategoryExpanded } from '../components/CategoryExpanded.jsx';

/**
 * Detailed Findings panel. Every visible category is rendered with its
 * expanded block open by default (no single-open constraint here — the
 * user is browsing the full set). A FilterPillBar narrows the set to
 * one category at a time; "All" is the default.
 */
export function DetailedFindings({ analysis, reportId }) {
  const categories = useMemo(
    () => (analysis?.categories || []).filter((c) => !c.hidden),
    [analysis],
  );
  const [activeId, setActiveId] = useState('all');

  const visible = activeId === 'all'
    ? categories
    : categories.filter((c) => String(c.id) === String(activeId));

  const dcmaPoints = analysis?.dcma?.points;

  return (
    <section className="detailed-findings" aria-label="Detailed findings">
      <FilterPillBar
        categories={categories}
        activeId={activeId}
        onChange={setActiveId}
      />
      {visible.length === 0 ? (
        <p className="table-empty">No categories match the selected filter.</p>
      ) : (
        <div className="findings-list">
          {visible.map((category, i) => (
            <div key={category.id} className="cat-block findings-block">
              <CategoryRow
                category={category}
                even={i % 2 === 1}
                open={true}
                onToggle={() => {}}
              />
              <CategoryExpanded
                category={category}
                reportId={reportId}
                dcmaPoints={dcmaPoints}
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
